import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { AmapUILoaderService } from '../../shared/amap-ui-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';

export namespace AMapUISimpleMarker {
  export interface Options<ExtraData = any> extends AMap.Marker.Options<ExtraData> {
    /**
     * æ ·å¼ä¸»é¢
     */
    iconTheme?: 'default' | 'fresh' | 'numv1' | 'numv2';
    /**
     * èæ¯å¾æ æ ·å¼
     */
    iconStyle?: string | object;
    /**
     * å¾æ åæ¯æå­
     */
    iconLabel?: string | object;
    /**
     * æ¯å¦æ¾ç¤ºå®ä½ç¹
     */
    showPositionPoint?: boolean | object;
    /**
     * åå»ºçDomå®¹å¨ä¸éå¸¦çclassï¼å¤ä¸ªclass nameç¨ç©ºæ ¼åå¼
     */
    containerClassNames?: string;
  }
}

const TAG = 'UISimpleMarker';

@Injectable()
export class UISimpleMarkerService implements Getter<any> {
  private marker: any;
  private marker$ = new ReplaySubject<any>(1);
  private ui = this.uiLoader.load('overlay/SimpleMarker') as Observable<any>;

  constructor(
    private amaps: AMapService,
    private uiLoader: AmapUILoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åç¹æ è®°
   */
  get() {
    return this.marker$.asObservable();
  }

  /**
   * åå»ºç¹æ è®° AMap.SimpleMarker
   * @param options éé¡¹
   * @param addToMap æ¯å¦ç´æ¥å è¿å°å¾
   */
  create(options: AMapUISimpleMarker.Options, addToMap = true) {
    return zip(this.ui, this.amaps.get()).pipe(
      map(([SimpleMarker, m]) => {
        if (addToMap) {
          options.map = m;
        }
        this.marker = this.ngZone.runOutsideAngular(() => new SimpleMarker(options));
        this.logger.d(TAG, 'new simple marker created.');
        this.marker$.next(this.marker);
        this.marker$.complete();
        return this.marker;
      }),
    );
  }

  /**
   * éæ¯ç¹æ è®°
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'simple marker destroyed.');
      this.marker = null;
    });
  }
}
